import Util from "../util.js";
import { Toast } from 'antd-mobile/lib';
import { getLoginState} from '../getPay.js';
import { getTempInfo } from '../common.js';

export const bankCardList = (text)=>{
	return {
		type: 'BANK_CARD_LIST',
		text
	}
}

export const bankCardNum = (text)=>{
	return {
		type: 'BANK_CARD_NUM',
		text
	}
}

export const HQTCardList = (text)=>{
	return {
		type: 'HQT_CARD_LIST',
		text
	}
}

export const bankCardListResetPS = (text)=>{
	return {
		type: 'BANK_CARD_LIST_RESET',
		text
	}
}


//请求加卡
export const addCardRequest = (params, succallback, errcallback)=>{
	return async (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback();
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		params.token = await getTempInfo('shortToken');
		Util.post(Util.url + '/api/account/addCardRequest', params, successCallback, errorCallback);
	}
}

//获取卡类型
export const getBankCardType = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/realnameauth/getBankName', params, successCallback, errorCallback);
	}
}

//获取可加卡银行的列表来取得paymentChannelId
export const getBankList = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/realnameauth/getBankCardList', params, successCallback, errorCallback);
	}
}

//鉴权申请
export const requestAuthentication = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.postNew(Util.url + '/api/v1/account/bankCard/authApply', params, successCallback, errorCallback);
	}
}

//鉴权确认
export const confirmAuthentication = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/realnameauth/authConfirm', params, successCallback, errorCallback);
	}
}
//添加银行卡
export const addBankCard = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.postNew(Util.url + '/api/v2/account/bankCard/addCard', params, successCallback, errorCallback);
	}
}
//解绑银行卡
export const unbindBankCard = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/account/closePaymentAccount', params, successCallback, errorCallback);
	}
}
//获取常见问题
export const getFAQ = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.responseMsg);
					errcallback(succ.responseMsg);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/cms/getQuestionListByCode', params, successCallback, errorCallback);
	}
}

//银联签约协议查询,新增接口app有网关，但给予投顾H5老项目单独简单处理不走网关，后期新项目投顾替代将会都需要走网关
export const getBankProtocollnfoList = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = async (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.postNew(Util.url + '/api/v1/account/bankCard/getBankProtocolInfoList', params, successCallback, errorCallback);
	}
}


// WEBPACK FOOTER //
// ./src/action/myCardsAction.js